/**
 * Normalize only the path delimiter, without re-encoding Unicode, changing
 * authority/case or removing query/hash values. The homepage keeps its slash.
 */
export function stripCanonicalTrailingSlash(value) {
  if (typeof value !== "string") return value;
  return value.replace(/^(https?:\/\/[^/?#]+)?(\/[^?#]*?)(\/+)([?#].*)?$/,
    (_match, origin = "", path, _slashes, suffix = "") => `${origin}${path}${suffix}`);
}
